<template>
    <main>
        <!-- <div class="banner">
            <div class="text">
                <h3>专业品质</h3>
                <h5>Professional quality, leading in India</h5>
                <h2>成就印界翘楚</h2>
            </div>
        </div> -->
        <slide-show :data="$root.banners"></slide-show>
        <div v-if="typeKey.length>0">
            <div class="produ">
                <div class="title">
                    <!-- <div class="active">精装盒</div> -->
                    <div v-for="item in typeKey" @click="getServiceList(item.value)" :class="{active:typeId==item.value}">{{item.label}}</div>
                </div>
                <div class="context">
                    <div class="item" v-for="i in list" :key="i.value">
                        <div class="techImg">
                            <video :src="i.videoContext">
                                your browser does not support the video tag
                            </video>
                            <div v-if="i.videoContext"  @click="play(i)">
                                <div class="mask"></div>
                                <img class="playBtn" src="../assets/images/play.png" alt="">
                            </div>
                        </div>
                        <div class="techName">{{i.videoTitle}}</div>
                    </div>
                </div>
            </div>
            <pager :xpages="pages" :xcurrent-page="pageNum" @pager="pageNum=$event"></pager>
        </div>
        
        <div v-else class="empty">
            暂无数据
        </div>
        
        <video-alert :videoUrl="videoUrl" ref="video"></video-alert>
    </main>
</template>
<style lang="less" scoped>
    @red: #e60012;
    
    .banner {
        height: 550px;
        background: url(../assets/images/tech/banner.jpg) center/cover no-repeat;
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        .text {
            position: relative;
            text-align: left;
            color: #FEFEFE;
            padding-left: 456px;

            h3 {
                font-size: 71px;
                line-height: 71px;
                font-weight: 400;
                margin: 0;
            }

            h5 {
                font-size: 24px;
                font-weight: 400;
                margin: 16px 0;
            }

            h2 {
                font-size:96px;
                line-height: 96px;
                font-weight: 400;
                margin: 0;
            }
        }
    }

    .produ {
        display: flex;
        min-height: 123px;
        margin-top: 1px;

        .title {
            width: 360px;
            font-size:18px;
            color: #353535;

            div {
                height: 50px;
                line-height: 50px;
                padding-right: 26px;
                text-align: right;
                border-bottom: 1px solid #D2D2D2;
                position: relative;
                cursor: pointer;
                white-space: nowrap;

                &:nth-child(1) {
                    border-top: 1px solid #D2D2D2;
                }

                &.active {
                    box-shadow:0px 0px 7px 0px rgba(0, 0, 0, 0.12);
                    border: none;
                    top: -1px;
                    background-color: #FFFFFF;

                    &:after {
                        display: inline-block;
                        content: '';
                        width: 5px;
                        height: 40px;
                        background-color: @red;
                        position: absolute;
                        right: -5px;
                        top: 5px;
                    }
                }
            }
        }

        .context {
            min-width: 1200px;
            display: flex;
            flex-wrap: wrap;
            margin-left: 40px;
            margin-top: 46px;

            .item {
                margin:0 14px 11px;
                    
                .techImg {
                    width: 340px;
                    height: 320px;
                    border:1px solid #D2D2D2;
                    border-radius:4px;
                    overflow: hidden;
                    position: relative;
                    cursor: pointer;

                    video,div {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    .mask {
                        background-color: #ffffff;
                        opacity: 0.5;
                    }
                    .playBtn {
                        position: absolute;
                        top: 137px;
                        left: 147px;
                        width: 47px;
                        height: 47px;
                    }
                }

                .techName {
                    font-size:14px;
                    font-weight:400;
                    color:#353535;
                    line-height: 50px;
                }
            }
        }

    }

    .empty {
        color: #888;
        line-height: 100px;
    }

</style>
<script>
    export default {
        data() {
            return {
                list:[],
                typeKey:[],
                typeId:'',
                videoUrl:''
            }
        },
        methods: {
            getTypeKey(){
                var that = this;
				ajax.call(this, {
					url: "/admin/category/typeKey",
					data: {
                        // SERVER_SORT服务,PRODUCT_SORT产品,DEVICE_SORT设备,TECHNOLOGY_SORT工艺,POSITION_SORT职位,VIDEO_SORT视频,OTHER_SORT其他
						typeKey : "VIDEO_SORT"
					},
					s(res) {
                        that.typeKey=res.data;
                        if(res.data.length > 0){
                            that.getServiceList(res.data[0].value)
                        }
                        
					}
				});
            },
            getServiceList(id){
                var that = this;
                that.typeId=id;
				that.getList();
            },
            getList(){
                var that = this;
				ajax.call(this, {
					url: "/bloc/video/list/bloc",
					data: {
                        typeId: that.typeId,
                        pageSize: 9
					},
					s(res) {
						that.list=res.data
					}
				});
            },
            play(item){
                this.videoUrl=item.videoContext;
                this.$refs.video.played();             
            }
           
        },
        mounted() {
            this.getTypeKey();
            if(this.$root.groupId){
                this.$root.getBanner(8);
            }
        },
        watch: {
			"$root.language"() {
				this.getTypeKey();
			},

		}
    }
</script>